import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initImagesCarousel = () => {
  const carousels = document.querySelectorAll(".images-carousel-frontend");

  carousels.forEach((carousel) => {
    if (carousel._initialized) return;
    carousel._initialized = true;

    const slides = carousel.querySelectorAll(".swiper-slide");
    const originalSlides = Array.from(slides).filter(
      (s) => !s.classList.contains("swiper-slide-duplicate"),
    );

    const swiper = new Swiper(carousel.querySelector(".swiper-container"), {
      modules: [Navigation, Autoplay],
      slidesPerView: 5,
      spaceBetween: 7,
      loop: true,
      grabCursor: true,
      speed: 700,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: carousel.querySelector(".swiper-image-carousel-button-next"),
        prevEl: carousel.querySelector(".swiper-image-carousel-button-prev"),
      },
      breakpoints: {
        0: { slidesPerView: 3, centeredSlides: true },
        640: { slidesPerView: 3 },
        1024: { slidesPerView: 5 },
      },
    });
    swiper.slides.forEach((slide) => {
      slide.addEventListener("click", () => {
        const realIndexAttr = slide.getAttribute("data-swiper-slide-index");
        if (realIndexAttr === null) return;

        const realIndex = Number(realIndexAttr);
        const clickedIndex = [...swiper.slides].indexOf(slide);
        const activeIndex = swiper.activeIndex;

        const diff = clickedIndex - activeIndex;

        if (diff === 0) return;

        if (diff > 0) {
          swiper.slideToLoop(realIndex, 700);
        } else {
          swiper.loopFix();
          swiper.slideToLoop(realIndex, 700);
        }
      });
    });

    gsap.fromTo(
      originalSlides.map((s) => s.querySelector("img")),
      { autoAlpha: 0, y: 50 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: {
          trigger: carousel,
          start: "top 95%",
          once: true,
        },
      },
    );

    const updateSlides = () => {
      carousel
        .querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)")
        .forEach((slide) => {
          const img = slide.querySelector("img");
          if (!img) return;

          if (slide.classList.contains("swiper-slide-active")) {
            gsap.to(img, {
              scale: 1,
              opacity: 1,
              duration: 0.5,
              ease: "power3.out",
            });
          } else {
            gsap.to(img, {
              scale: 0.87,
              opacity: 1,
              duration: 0.5,
              ease: "power3.out",
            });
          }
        });
    };

    updateSlides();
    swiper.on("slideChange transitionEnd", updateSlides);
    swiper.init();
  });
};

document.addEventListener("DOMContentLoaded", initImagesCarousel);
window.addEventListener("load", initImagesCarousel);
